import { SearchMode } from "../types";

export const getSearchIcon = (searchMode: SearchMode) => {
  return searchMode === SearchMode.Layers ? "layers" : searchMode === SearchMode.Objects ? "points" : "search";
};
